import type { PaymentCorridor, PaymentDirection } from "@/shared/services/payments/paymentCorridors.service";

export interface CorridorScope {
  rail?: string;
  country?: string;
  currency?: string;
  direction?: PaymentDirection;
}

const inScope = (corridor: PaymentCorridor, scope: CorridorScope): boolean =>
  (!scope.rail || corridor.rail === scope.rail) &&
  (!scope.country || corridor.country === scope.country) &&
  (!scope.currency || corridor.currency.toUpperCase() === scope.currency.toUpperCase()) &&
  (!scope.direction || corridor.direction === scope.direction);

/**
 * Nothing in the scope runs right now and a rail switched off by Coloca is part of why. Members read that as
 * maintenance; a scope that only lacks pricing reads as "not available for your organization" instead.
 */
export function isScopeInMaintenance(corridors: PaymentCorridor[], scope: CorridorScope): boolean {
  const matching = corridors.filter((corridor) => inScope(corridor, scope));
  return (
    matching.length > 0 &&
    !matching.some((corridor) => corridor.available) &&
    matching.some((corridor) => corridor.unavailable_reason === "rail_disabled")
  );
}

/**
 * Every corridor of the currency is switched off. Converting into it still works, but that money can only
 * leave through support, so the convert screens say so before converting.
 */
export function isCurrencyInMaintenance(corridors: PaymentCorridor[], currency: string): boolean {
  const matching = corridors.filter((corridor) => inScope(corridor, { currency }));
  return matching.length > 0 && matching.every((corridor) => corridor.unavailable_reason === "rail_disabled");
}
